<div class="row">
  <div class="col-12">
    <sb-card>
      <div card-header>

      </div>
      <div card-header-more class="d-flex">
        <sb-boolean-toggles class="mr-1" [toggles]="initialBooleans"
                            (toggleChange)="boolChange($event?.id, $event?.value)">
          {{ 'lang.globals.statusFilter' | translate }}
        </sb-boolean-toggles>
        <sb-threeway-toggle-collection [titles]="{ productive: 'Productive'}" [toggles]="initialToggles"
                                       (modelChange)="toggleChange($event)"></sb-threeway-toggle-collection>
        <sb-comp-dropdown-select
          *ngPermissions="permissionService.Permission.cull_list"
          [showSubmit]="true"
          [inputData]="culls" [dropDownDatatype]="'PLAYER_CULLS'"
          (selectedDataEmitter)="update($event, 'PLAYER_CULLS')" [showColumnIcon]="false"
          [msOptions]="msCullOptions" (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
          [selectedInputData]="filteredPlayerCulls ? filteredPlayerCulls : []">
        </sb-comp-dropdown-select>
        <div class="ml-2">
          <select (ngModelChange)="setChannelFilter($event)" [(ngModel)]="channel" class="form-select"
                  name="ChannelFilter" label="Channel filter">
            <option [ngValue]="undefined">{{ 'lang.statisticOverview.allChannels' | translate }}</option>
            <option [ngValue]="option" *ngFor="let option of channelOptions"
                    [ngStyle]="{'font-style': option.name.includes('(No Data)') ? 'italic' : null }">{{ option.name }}
            </option>
          </select>
        </div>
      </div>
    </sb-card>
  </div>
  <div class="col-xxl-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
    <ng-container *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
      <sb-card [loadingDelay]="1" [loading]="!barChart?.loadingDone" [halfHeight]="true">
        <div card-header>
          <h3>{{ 'lang.globals.playerStatus' | translate }}</h3>
          <small><span
            class="font-weight-bold blue">{{ 'lang.statisticOverview.onlyOne' | translate }}&nbsp;</span> {{ 'lang.statisticOverview.canApply' | translate }}
          </small>
        </div>
        <div card-body>
          <sb-chart chartType="barChart" *ngIf="barChart?.loadingDone && loading===false" [chartData]="barChart"></sb-chart>
        </div>
      </sb-card>
    </ng-container>
    <ng-container *ngPermissions="[permissionService.Permission.ss_nm_reporting]">
      <sb-card [loadingDelay]="1" [loading]="!radarChart?.loadingDone" [halfHeight]="true">
        <div card-header>
          <h3>{{ 'lang.statisticOverview.playerAttributes' | translate }}</h3>
          <small><span
            class="font-weight-bold blue">{{ 'lang.statisticOverview.oneOrMore' | translate }}&nbsp;</span> {{ 'lang.statisticOverview.canApply' | translate }}
          </small>
        </div>
        <div card-body>
          <sb-chart chartType="barChart" *ngIf="loading===false" [chartData]="radarChart"></sb-chart>
        </div>
      </sb-card>
    </ng-container>
  </div>
  <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]" class="col-xxl-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
    <sb-card>
      <div card-fit>
        <sb-comp-cluster-map [clusters]="clusters" [loading]="clusterMapLoading"
                             (minMaxPointsChange)="refreshClusterMap($event)"></sb-comp-cluster-map>
      </div>
    </sb-card>
  </div>
  <div class="col-12">
    <sb-card>
      <div card-header>

      </div>
      <div card-header-more>
        <!--          <div class="mr-2">
                    <div id="from-box" (click)="changeFrom()" class="cursor-pointer btn btn-outline-primary">
                      &nbsp;&nbsp;{{getFrom()}} &nbsp;<fa-icon [icon]="'chevron-up'"></fa-icon>
                    </div>
                  </div>
                  <div class="mr-2">
                    <div id="till-box" (click)="changeTill()" class="cursor-pointer btn btn-outline-primary">
                      &nbsp;&nbsp;{{getTill()}} &nbsp;<fa-icon [icon]="'chevron-up'"></fa-icon>
                    </div>
                  </div>
                  <button (click)="selectFilter()" style="width: 130px" class="btn mr-2 btn-sm" [ngClass]="getFilterSelectClass()">
                    {{getFilterText()}} &nbsp;<fa-icon icon="chevron-up"></fa-icon>
                  </button>
                  <sb-button (click)="getTimeFrameData()" [disabled]="loading" [loading]="loading" classes="glow btn-primary mr-0">{{'lang.reporting.getData' | translate}}</sb-button>-->
        <sb-comp-chart-control [from]="from" [till]="till" (dateChange)="setTimeFrame($event)"
                               (intervalChange)="setInterval($event)"
                               (filterChange)="setPlayerCulls($event)"></sb-comp-chart-control>
      </div>
    </sb-card>
  </div>
  <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]" class="col-xxl-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
    <sb-player-time-data [from]="from" [till]="till" [chartHeight]="300" [resolveInCom]="false" [inputData]="timeFrameData"
                         [halfHeight]="false"></sb-player-time-data>
  </div>
  <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]" class="col-xxl-6 col-xl-6 col-lg-6 col-sm-12 col-xs-12">
    <sb-comp-service-time-data [from]="from" [till]="till" [chartHeight]="300" [resolveInCom]="false"
                               [inputData]="timeFrameData" [halfHeight]="false"></sb-comp-service-time-data>
  </div>
  <div *ngPermissions="[permissionService.Permission.ss_nm_reporting]" class="col-12">
    <sb-comp-heatmap-status [from]="from" [till]="till"></sb-comp-heatmap-status>
  </div>
</div>



